import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * The branding color swatch: a readonly input whose background shows the
 * current color and which opens the ngx-color-picker overlay on click
 * (the store-branding pattern, previously raw markup ×9). The `.branding-input`
 * box styling lives here, centrally.
 *
 * Two-way: `[(color)]`. `(closed)` fires when the picker overlay closes
 * (the screen's "mark dirty" hook).
 */
@Component({
  selector: 'app-brand-color-picker',
  templateUrl: './brand-color-picker.component.html',
  styleUrls: ['./brand-color-picker.component.scss'],
})
export class BrandColorPickerComponent {
  @Input() color = '';
  /** ngx-color-picker overlay position ('bottom' default, 'top' near footer). */
  @Input() position = 'bottom';
  /** Optional data-testid on the input for e2e targeting. */
  @Input() testId: string | null = null;

  @Output() colorChange = new EventEmitter<string>();
  @Output() closed = new EventEmitter<string>();

  onColorPickerChange(value: string): void {
    this.color = value;
    this.colorChange.emit(value);
  }
}
